<div class="metric-box" [ngClass]="theme">
	<div class="header">
		<i class="icon" [ngClass]="icon"></i>
		<h3>{{ title }}</h3>
	</div>

	<div class="metric-row" *ngFor="let item of items">
		<div class="metric-content">
			<div class="metric-header">
				<div class="label"><strong [class.metric-label-link]="item.name" (click)="onLabelClick(item)">{{ item.label }}</strong></div>
				<div class="value-text">
					<strong *ngIf="item.displayValue">{{ item.displayValue }}</strong>
					<span *ngIf="item.showPercentage">
						<b> ({{ item.percentage }}%)</b>
					</span>
				</div>
			</div>
			<div class="bar-container">
				<div class="bar" [ngClass]="[item.colorClass || '', getSeverity(item.value)]" [style.width.%]="item.value"></div>
			</div>
		</div>
	</div>
</div>
